import { Injectable } from '@angular/core';

export interface FleetBreakdownReturnContext {
  fleetId: number;
  callcentreId: number;
  cvv: string;
}

/**
 * Keeps the return route only for the lifetime of the current Angular session.
 * It intentionally does not use localStorage or sessionStorage.
 */
@Injectable({ providedIn: 'root' })
export class FleetBreakdownNavigationService {
  private returnContext: FleetBreakdownReturnContext | null = null;

  public setReturnContext(context: FleetBreakdownReturnContext): void {
    this.returnContext = context;
  }

  public getReturnContext(): FleetBreakdownReturnContext | null {
    return this.returnContext;
  }
}
